import { apiClient } from '../../gateways/api'
import type { Projectdossier } from '../types/Projectdossier'

export { linkProjectToProjectdossier }

const linkProjectToProjectdossier = async ({
  id,
  projectId,
}: {
  id: string
  projectId: string
}): Promise<Projectdossier> => {
  const { data } = await apiClient({
    url: `/rest/projectdossier/${id}/project/${projectId}`,
    method: 'PUT',
  })
  return data
}
